import React, { useState } from "react";
import FeedbackStepLayout from "../FeedbackStepLayout";

const Step2Struggle = ({ data, updateData, nextStep, prevStep }) => {
  const challenges = [
    "Trouble finding help",
    "Lack of resources / support",
    "Communication with team",
    "Stress / pressure",
    "Other",
  ];

  const [selected, setSelected] = useState(data.struggles || []);

  const toggleSelect = (item) => {
    setSelected((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const handleNext = () => {
    updateData("struggles", selected);
    nextStep();
  };

  return (
    <FeedbackStepLayout
      title="Just part of the process..."
      subtitle="What were some challenges?"
      step={2}
      totalSteps={5}
      onNext={handleNext}
      onBack={prevStep}
    >
      <div className="flex flex-col gap-3 mt-6">
        {challenges.map((item, index) => {
          const isChecked = selected.includes(item);
          return (
            <button
              key={index}
              onClick={() => toggleSelect(item)}
              className="flex items-center gap-3 text-left group focus:outline-none"
            >
              {/* Checkbox */}
              <div
                className={`w-4 h-4 rounded-[3px] border transition-all duration-200 ${
                  isChecked
                    ? "bg-black border-black"
                    : "border-zinc-600 group-hover:border-black"
                }`}
              />
              {/* Label */}
              <span
                className={`text-sm font-medium ${
                  isChecked ? "text-black" : "text-zinc-700"
                }`}
              >
                {item}
              </span>
            </button>
          );
        })}
      </div>

    </FeedbackStepLayout>
  );
};

export default Step2Struggle;
